<aura-edit-wrapper
  title="Type d'exercice & Réseau"
  [(isEditing)]="isEditing"
  [isAllowedToEdit]="isAllowedToEdit()"
  [showDivider]="true"
  (saved)="onSave($event)"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing()) {
    <etxe-agent-network-form
      [agentType]="resolvedAgentType()"
      [network]="currentNetwork()"
      (validityChanged)="editWrapper.onValidityChanged($event)"
      (dtoChanged)="editWrapper.onDtoChanged($event)"
    />
  } @else {
    <etxe-agent-network-display
      [profile]="initialProfile()"
      [agentType]="resolvedAgentType()"
      [network]="currentNetwork()"
    />
  }
</aura-edit-wrapper>
